import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface artistState {
  activeArtist: string;
}

const initialState: artistState = {
  activeArtist: ""
};

export const ActiveArtist = createSlice({
  name: "activeArtist",
  initialState,
  reducers: {
    setActiveArtist: (state, action: PayloadAction<string>) => {
      state.activeArtist = action.payload;
    },
    resetActiveArtist: (state) => {
      state.activeArtist = "";
    }
  }
});

// Action creators are generated for each case reducer function
export const { setActiveArtist, resetActiveArtist } = ActiveArtist.actions;

export default ActiveArtist.reducer;
